import { Flex, Box, Image, Button, chakra } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import getImageSrc from "src/utils/getImageSrc";
import getVideoSrc from "src/utils/getVideoSrc";
import { H3, BodyText2 } from "src/atoms/typography";
import dialogContent from "src/modules/purchase/components/dialogContentEnum";
import CloseButton from "src/atoms/CloseButton";

const Video = chakra("video");

export default function FreemiumView({
  onClose,
  onClick,
  contentSelector,
  updatePopoverStyle
}) {
  const { t } = useTranslation();
  const hasImage = dialogContent[contentSelector].imageName;
  const hasVideo = dialogContent[contentSelector].videoName;
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      position="relative"
      h="100%"
      w="100%"
      justify="center"
      align="center"
    >
      <Flex
        position="relative"
        bg="surfaceElevated1"
        px="24px"
        pt="24px"
        pb="16px"
        w="480px"
        flexDirection="column"
        alignItems="center"
        borderRadius="12px"
      >
        <Box position="absolute" top="12px" right="12px">
          <CloseButton fill="mediumEmphasis" onClick={onClose} />
        </Box>

        <Flex columnGap="16px" alignItems="center" justifyContent="center">
          {hasImage && (
            <Image
              width="208px"
              height="132px"
              src={getImageSrc(dialogContent[contentSelector].imageName)}
            />
          )}
          {hasVideo && (
            <Video
              height="132px"
              loop
              borderRadius="16px"
              muted
              autoPlay
              playsInline
              src={getVideoSrc(dialogContent[contentSelector].videoName)}
            />
          )}
          <Box>
            <H3 mb="8px" color="highEmphasis">
              {t(dialogContent[contentSelector].heading)}
            </H3>
            <BodyText2 color="mediumEmphasis">
              {t(dialogContent[contentSelector].text)}
            </BodyText2>
          </Box>
        </Flex>

        <Button
          mt="24px"
          variant="containedPrimary"
          onClick={() => {
            updatePopoverStyle({
              width: "632px",
              height: "424px"
            });
            onClick();
          }}
        >
          {t("buttons.upgradeToPremium")}
        </Button>
      </Flex>
    </Flex>
  );
}
